import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { NavBar } from './NavBar';
import { HOME_URL } from '../constants/urls';
import Images from '../assets/images';

const Header = ({
  onLoginClick,
  isLoggedIn,
  displayName,
  onLogoutClick,
  isAuthorizing,
}) => {
  const { t: translator } = useTranslation();
  return (
    <div className="agora-app-header">
      <div className="application-name">
        <Link to={HOME_URL}>
          <p className="p-style white-text">
            {translator('general.applicationName')}
          </p>
        </Link>
      </div>
      <div className="bar">
        <h1 className="SFont h3-style">
          {translator('general.municipalityName')}
        </h1>
        <div className="far-side">
          <div className="logo-far-side">
            <Link
              to={HOME_URL}
              aria-label={translator('ariaLabel.navigateToCurrentHearings')}
            >
              {!Images.headerLogo ? null : (
                <img
                  src={Images.headerLogo}
                  alt={translator('general.municipalityLogoAltText')}
                  className="logo-far-side-image"
                />
              )}
            </Link>
          </div>
          <NavBar
            onLoginClick={onLoginClick}
            onLogoutClick={onLogoutClick}
            displayName={displayName}
            isLoggedIn={isLoggedIn}
            isAuthorizing={isAuthorizing}
          />
        </div>
      </div>
    </div>
  );
};

export { Header };
